import prepareBody from '../utils/prepareBody';
import { selectPlanId, selectRunnerId } from './auth';
import { GET_RACE_SUCCESS } from './race';
import { stripeKey } from '../constants';

export const FETCH_THEME = 'theme/FETCH_THEME';
export const FETCH_THEME_SUCCESS = 'theme/FETCH_THEME_SUCCESS';
export const FETCH_THEME_FAILURE = 'theme/FETCH_THEME_FAILURE';
export const FETCH_BANNERS = 'theme/FETCH_BANNERS';
export const FETCH_BANNERS_SUCCESS = 'theme/FETCH_BANNERS_SUCCESS';
export const FETCH_BANNERS_FAILURE = 'theme/FETCH_BANNERS_FAILURE';

export const defaultStyling = {
    actionColor: '#333',
    primaryColor: '#666',
    secondaryColor: '#999',
    footerLogo: null,
    footerLogoLink: null,
    footerHelpLink: 'https://help.runtrix.com',
    banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    navBarLogo: '',
    logo: null,
    raceFooter: '#333',
    raceFooterLink: '#fff',
    navBar: '#333',
    navBarLink: '#fff',
    training_banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    analytics_banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    manage_banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    races_banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    runhub_banner: `${process.env.RTAPI_URL}/images/Generic_banner.png`,
    themeId: 0,
    stripeIcon: `${process.env.RTAPI_URL}/images/coach-avatar.png`,
    stripePublishable: stripeKey,
};

const mapStateFromRace = result => ({
    footerLogo: result.footer_logo,
    footerLogoLink: result.footer_logolink,
    footerHelpLink: result.footer_helplink,
    footerTosLink: result.footer_toslink,
    footerPrivacyLink: result.footer_privacylink,
    actionColor: result.race_actioncolor,
    primaryColor: result.race_primarycolor,
    landingVideo: result.landing_video,
    secondaryColor: result.race_secondarycolor,
    logo: result.race_logo,
    raceFooter: result.race_footer,
    raceFbGroupLink: result.race_fbgroup_url,
    raceTwitterHandle: result.race_twitter_handle,
    raceInstagramHandle: result.race_instagram_handle,
    raceFooterLink: result.race_footerLink,
    navBar: result.race_navbar,
    navBarLink: result.race_navbarLink,
    navBarLogo: result.race_navbar_logo,
    banner: result.race_banner,
    themeId: result.race_theme,
});

const mapStateFromTheme = result => ({
    footerLogo: result[0].footer_logo,
    footerLogoLink: result[0].footer_logolink,
    footerHelpLink: result[0].footer_helplink,
    footerTosLink: result[0].footer_toslink,
    footerPrivacyLink: result[0].footer_privacylink,
    actionColor: result[0].race_actioncolor,
    primaryColor: result[0].race_primarycolor,
    landingVideo: result[0].landing_video,
    secondaryColor: result[0].race_secondarycolor,
    logo: result[0].race_logo,
    raceFooter: result[0].race_footer,
    raceFbGroupLink: result[0].race_fbgroup_url,
    raceTwitterHandle: result[0].race_twitter_handle,
    raceFooterLink: result[0].race_footerLink,
    navBar: result[0].race_navbar,
    navBarLink: result[0].race_navbarLink,
    navBarLogo: result[0].race_navbar_logo,
    banner: result[0].race_banner,
    rightSideMoran: result[0].right_sidemoran,
    rightSideStep1: result[0].rightSideStep1,
    rightSideStep2: result[0].rightSideStep2,
    rightSideStep3: result[0].rightSideStep3,
    rightSideStep4: result[0].rightSideStep4,
    stripeIcon: result[0].race_stripe_icon,
    stripePublishable: result[0].race_stripe_publishable,
});

export default function theme(state = defaultStyling, action) {
    switch (action.type) {
        case FETCH_THEME_SUCCESS:
            return {
                ...state,
                ...mapStateFromTheme(action.result),
                themeId: action.themeId,
            };
        case GET_RACE_SUCCESS:
            return {
                ...state,
                ...mapStateFromRace(action.result),
            };
        case FETCH_BANNERS_SUCCESS:
            return {
                ...state,
                ...action.result,
            };
        case FETCH_THEME_FAILURE:
            return {
                ...state,
                ...defaultStyling,
                themeId: action.themeId,
            };
        default:
            return state;
    }
}

export const getTheme = (themeId = 0) => ({
    types: [FETCH_THEME, FETCH_THEME_SUCCESS, FETCH_THEME_FAILURE],
    promise: () => fetch(`${process.env.RTAPI_URL}/API_theme.php`, {
        method: 'POST',
        body: prepareBody({
            theme_id: themeId,
        }),
    }).then(res => res.json()),
    themeId,
});

export const getBanners = () => ({
    types: [FETCH_BANNERS, FETCH_BANNERS_SUCCESS, FETCH_BANNERS_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_banners.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
        }),
    }).then(res => res.json()),
});

export const selectThemeId = state => state.theme.themeId;

export const isNyrr = themeId => [2, 3, 6, 7, 8].includes(+themeId);



/** WEBPACK FOOTER **
 ** ./src/redux/theme.js
 **/